<div
  class="blocking-notice__backdrop"
  [class.blocking-notice__backdrop--visible]="open()"
  aria-hidden="true"
></div>

@if (open()) {
  <section
    #dialog
    class="blocking-notice"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="blocking-notice-title"
    [attr.aria-describedby]="
      emphasis()
        ? 'blocking-notice-body blocking-notice-emphasis'
        : 'blocking-notice-body'
    "
    tabindex="-1"
  >
    <div
      class="blocking-notice__header"
      [class.blocking-notice__header--mascot-right]="mascotPosition() === 'right'"
    >
      @if (mascotSrc()) {
        <img
          class="blocking-notice__mascot"
          [src]="mascotSrc()"
          alt=""
          loading="lazy"
          [width]="mascotWidth()"
          [height]="mascotHeight()"
        />
      }
      <div class="blocking-notice__text">
        <h2 id="blocking-notice-title" class="blocking-notice__title">{{ title() }}</h2>
        <p id="blocking-notice-body" class="blocking-notice__body">{{ body() }}</p>
      </div>
    </div>

    @if (emphasis()) {
      <p id="blocking-notice-emphasis" class="blocking-notice__emphasis">
        {{ emphasis() }}
      </p>
    }

    <label class="blocking-notice__check">
      <input
        type="checkbox"
        [checked]="acknowledged()"
        (change)="onToggleAck($event)"
      />
      <span>{{ ackLabel() }}</span>
    </label>

    <div class="blocking-notice__actions">
      <app-button
        variant="primary"
        size="md"
        type="button"
        [disabled]="!acknowledged()"
        (click)="onAcknowledge()"
      >
        {{ ctaLabel() }}
      </app-button>
    </div>
  </section>
}
